import React, {Component} from 'react';
import _ from 'lodash';
import Validation from '../Validation';
import Label from '../../components/Label';
import styled, {withTheme} from 'styled-components';

class FieldWrapper extends Component {
  static defaultProps = {
    hideValidation: false,
    hideLabel: false
  };

  constructor(props) {
    super(props);
    this.validate = this.validate.bind(this);
    this.setValue = this.setValue.bind(this);

    const {hasErrors, hasWarnings, hasInfos, value} = props;

    this.state = {
      showValid: hasErrors === false && hasWarnings === false && hasInfos === false && !_.isNil(value) && value !== ''
    };
  }

  validate() {
    this.setState({
      showValid: true
    });
    this.props.validate();
  }

  setValue(val) {
    this.setState({
      showValid: false
    });
    this.props.setValue(val);
  }

  placeholderSuffix(required, theme) {
    if (required && (theme?.requiredLabel?.display || 'none') !== 'none') {
      return ' *'
    }
    if (!required && (theme?.optionalLabel?.display || 'inline') !== 'none') {
      return ' (optioneel)';
    }
    return '';
  }

  render() {
    const {
      label,
      value,
      list,
      errors,
      warnings,
      infos,
      placeholder,
      hasErrors,
      hasWarnings,
      hasInfos,
      hideLabel,
      required,
      disabled,
      width,
      inline,
      name,
      inputType,
      style,
      children,
      noMargin,
      sideBySide,
      theme,
      largeValidationGap,
      ...rest
    } = this.props;
    const {showValid} = this.state;
    const isValid = hasErrors === false && hasWarnings === false && hasInfos === false && !_.isNil(value) && value !== '';

    let formattedPlaceholder = placeholder;
    if (hideLabel && _.isString(formattedPlaceholder)) {
      formattedPlaceholder += this.placeholderSuffix(required, theme);
    }

    const Comp = React.createElement(this.props.inputComponent, {
      ...rest,
      value: _.isNil(value) ? '' : value,
      setValue: this.setValue,
      validate: this.validate,
      placeholder: formattedPlaceholder,
      isValid: isValid && showValid,
      hasErrors: hasErrors,
      list,
      label,
      isRequired: (_.isNil(value) || value === '') && hasErrors,
      disabled,
      width,
      inline,
      isChecked: value === true,
      name,
      inputType,
      noMargin
    });

    if (sideBySide) {
      const SideBySide = styled.div`
        display: grid;
        grid-template-columns: 1fr 100px;
        align-items: center;
        margin-bottom: ${props => _.get(props, ['theme', 'horizontalField', 'marginBottom'], '-10px')};
      `;

      return (
        <div id={name} style={style}>
          <SideBySide>
            {hideLabel === false && !_.isNil(label) &&
              <Label label={label} {...{hasErrors, hasWarnings, hasInfos}} isOptional={!required} />}
            {Comp}
          </SideBySide>
          {!this.props.hideValidation && <Validation {...{errors, warnings, infos, noMargin, largeValidationGap}} />}
          {children}
        </div>
      );
    }

    return (
      <div id={name} style={style}>
        {hideLabel === false && !_.isNil(label) &&
          <Label label={label} {...{hasErrors, hasWarnings, hasInfos}} isOptional={!required} />}
        {Comp}
        {!this.props.hideValidation && <Validation {...{errors, warnings, infos, noMargin, largeValidationGap}} />}
        {children}
      </div>
    );
  }
}

export default withTheme(FieldWrapper);
